module.exports = __webpack_public_path__ + "img/Good Student Award 7.db64cf14.png";